import { render } from "./order_text.vue?vue&type=template&id=7e44e975&scoped=true"
import script from "./order_text.vue?vue&type=script&lang=js"
export * from "./order_text.vue?vue&type=script&lang=js"

import "./order_text.vue?vue&type=style&index=0&id=7e44e975&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e44e975"]])

export default __exports__